import React from "react";
import { MapPin } from "lucide-react";
import ContactForm from "@/components/site/ContactForm";
import { useSiteProfile } from "@/hooks/useSiteProfile";

export default function Contact() {
  const profile = useSiteProfile();
  const location = [profile?.address_locality, profile?.address_region]
    .filter(Boolean)
    .join(", ");
  return (
    <section
      id="contact"
      className="relative py-16 sm:py-32 bg-accent text-accent-foreground overflow-hidden"
    >
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-40 -right-20 w-[34rem] h-[34rem] rounded-full bg-accent-foreground/5 blur-3xl" />
        <div className="absolute -bottom-32 -left-20 w-[26rem] h-[26rem] rounded-full bg-accent-foreground/5 blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20">
          <div>
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-accent-foreground/70">
              Let's Talk
            </span>
            <h2 className="mt-4 font-heading font-extrabold text-4xl sm:text-5xl text-balance">
              Let's build your business website — something worth keeping.
            </h2>
            <p className="mt-6 text-lg text-accent-foreground/75 leading-relaxed max-w-md">
              Tell us about your business website project. We'll reply within one business day.
            </p>
            <div className="mt-10 space-y-5">
              {location && (
                <div className="flex items-center gap-4">
                  <span className="w-11 h-11 rounded-2xl bg-accent-foreground/10 flex items-center justify-center">
                    <MapPin size={18} />
                  </span>
                  <span className="text-accent-foreground/90">{location}</span>
                </div>
              )}
              <p className="text-accent-foreground/70 max-w-md leading-relaxed">
                Send a few details and we'll reply by email within one business
                day.
              </p>
            </div>
          </div>

          <div className="bg-accent-foreground/[0.04] backdrop-blur-sm rounded-[1.75rem] border border-accent-foreground/15 p-7 sm:p-9">
            <ContactForm />
          </div>
        </div>
      </div>
    </section>
  );
}